import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';

import { Util } from 'src/shared/util/util';
import { GuidebookCardPhoto, PickedImage } from 'src/shared/services/guidebook-photos.service';

import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';

/** What the native picker rejects with when the host backs out of it. */
const PICKER_CANCELLED = 'User cancelled photos app';

/**
 * The photos on one guidebook card: side by side, a delete button on each photo and
 * an "Add photos" link. It only asks; the page saves, since a save can outlive the card.
 */
@Component({
  selector: 'guidebook-card-photos',
  templateUrl: './guidebook-card-photos.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TidyUiComponentsModule],
})
export class GuidebookCardPhotosComponent {

  private readonly util = inject(Util);

  readonly cardKey = input.required<string>();
  readonly photos = input<GuidebookCardPhoto[]>([]);
  readonly isSaving = input(false);
  readonly addPhotos = output<PickedImage[]>();
  readonly removePhoto = output<number>();

  readonly pickerId = computed(() => `gbd-photos-${this.cardKey()}`);

  onPhotosAdded(picked: PickedImage[]) {
    if (!picked?.length || this.isSaving()) { return; }
    this.addPhotos.emit(picked);
  }

  onPhotoRemoved(photoId: number) {
    if (!photoId || this.isSaving()) { return; }
    this.removePhoto.emit(photoId);
  }

  onFileError(error: unknown) {
    if ((error as { message?: string })?.message === PICKER_CANCELLED) { return; }
    this.util.showError(typeof error === 'string' ? error : 'Could not add that file. Please try again.');
  }
}
